import axios from 'axios';

const api = axios.create({
    baseURL: '/',
    withCredentials: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    headers: {
        'Content-Type': 'application/json',
    }
});

api.interceptors.request.use(config => {
    const params = new URLSearchParams(window.location.search);
    const flow = params.get('flow');
    const appearance = params.get('appearance');
    if ((flow || appearance) && config.url?.startsWith('/api/auth/') && config.url !== '/api/auth/context') {
        config.params = { ...config.params, ...(flow ? { flow } : { appearance }) };
    }
    return config;
});
export default api;